import * as React from 'react';

import { Tag } from 'antd';

function BaseOfferTag() {
  return <Tag color='processing'>Oferta base</Tag>;
}

export { BaseOfferTag };
